<template lang="pug">
.contents(v-if="section" :class="{ 'is-dragging': dragging }")
    draggable(
        v-if="filteredContents && filteredContents.length"
        v-model="contents"
        :group="`${section.id}:contents`"
        :disabled="!edit"
        handle="h4.handle"
        :options="{ forceFallback: true }"
        drag-class="custom-ghost"
        @start="dragging = true"
        @end="dragging = false"
    )
        //- NOTE: transition flickers for category page teaser
        //- transition-group(name="slide-decent-vertical")
        .group(
            v-for="(content, i) in contents" :key="content.id"
            v-if="!skip(content)"
        )
            input-content(
                :section="section"
                :content="content"
                :config="config"
                :options="options"
                :index="i"
                :section-settings="sectionSettings"
                :section-setting-values="sectionSettingValues"
                :sortable="sortable"
                :edit="edit"
            )
    el-button.add-content(
        v-if="allowedToAddContent && edit && !hideAddButton"
        circle
        type="success"
        size="mini"
        icon="el-icon-fa-plus fas"
        @click="addContent"
    )
</template>

<i18n>
{
    "de": {
        "Add content": "Inhalt hinzufügen"
    }
}
</i18n>

<script>

import _ from 'lodash'
import uniqid from 'uniqid';
import { addContentToSection, sortContents } from '@/helpers'

import store from '@/store'
import { useSetupStore } from '@/stores'
// import router from '@/router'

import draggable from 'vuedraggable'
import InputContent from './InputContent'

export default {
    name: 'InputContents',
    props: {
        section: {
            type: Object,
            required: false
        },
        config: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        edit: {
            type: Boolean,
            required: true
        },

        // all setting values as associative object (key: value)
        sectionSettingValues: {
            type: Object,
            default: () => {
                return {}
            }
        },
        sectionSettings: {
            type: Array,
            required: false
        },
        hideAddButton: {
            type: Boolean,
            default: false
        },
        autoAddFirst: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            dragging: false,
        }
    },
    components: {
        draggable,
        InputContent,
    },
    watch: {
        filteredContentsLength: {
            immediate: true,
            handler() {
                this.ensureFirstContent()
            }
        },
        config() {
            this.ensureFirstContent()
        },
        section() {
            this.ensureFirstContent()
        },
    },
    computed: {
        sortable() {
            return _.get(this.config, 'max', 1) > 1
                && this.filteredContents.length > 1
        },
        contents: {
            get() {
                const contents = _.get(this.section, 'contents') || []

                return contents

                    // NOTE: filter breaks the draggable list
                    // .filter(el => el.key === this.config.key)

                    // NOTE: sort creates infinite loop
                    // .sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))
            },
            set(sorted) {
                // sort
                let contents = _.get(this.section, 'contents') || []
                contents.forEach(content => {
                    const i = sorted.findIndex(el => el.id === content.id)
                    content.position = i + 1
                });
                sortContents(contents)
            }
        },
        filteredContents() {
            // && this.checkConditions(content)
            return _.cloneDeep(this.contents)
                .filter(el => el.key === this.config.key)
        },
        filteredContentsLength() {
            return this.filteredContents.length
        },
        allowedToDelete() {
            return _.get(this.config, 'min', 1) < this.filteredContents.length
        },
        allowedToAddContent() {
            return _.get(this.config, 'max', 1) > this.filteredContents.length
        },
        setupStore() {
            return useSetupStore()
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions
        },
    },
    methods: {
        skip(content) {
            return !this.filteredContents.some(el => el.id === content.id)
        },
        // TODO: revisit
        checkConditions(content) {
            let valid = true

            // eslint-disable-next-line no-unused-vars
            const settings = this.sectionSettingValues;
            const enabledExtensions = this.enabledExtensions;
            try {
                const conditions = content.conditions
                if (conditions && conditions.length) {
                    conditions.forEach(o => {
                        if (valid === false) return

                        const { type, condition } = o
                        switch (type) {
                            case 'eval':
                                valid = eval(condition)
                                break;

                            default:
                                valid = false
                        }
                    })
                }
            } catch (error) {
                // eslint-disable-next-line
                console.error(error);
                valid = false
            }

            return valid
        },
        addContent() {
            // const contents = _.get(this.section, 'contents') || []
            // const position = Math.max(...contents.map(o => o.position), 1)

            // // add content to menu item > page > section > contents
            // const payload = {
            //     i: this.i,
            //     s: this.s,
            //     config: this.config,
            //     content: {
            //         position
            //     },
            // }
            // store.commit(`${this.module}/form/addContent`, payload)

            addContentToSection(this.section, this.config)
        },
        ensureFirstContent() {
            if (!this.autoAddFirst || !this.edit || !this.section || !this.config) return
            if (this.filteredContentsLength > 0) return
            if (!this.allowedToAddContent) return

            addContentToSection(this.section, this.config)
        },
    }
}
</script>

<style lang="sass" scoped>
.content + .content:not(.email-content)
    margin-top: 2rem
    padding-top: 2rem
    border-top: 3px dotted $--color-primary
button.add-content
    // margin-bottom: 1rem
    margin-bottom: .5rem

// .contents.is-dragging::v-deep
//     .fields,
//     .delete-content
//         display: none
// .group.sortable-chosen.sortable-ghost::v-deep .fields
//     display: none
</style>
